'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_Node = require('react').babelPluginFlowReactPropTypes_proptype_Node || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var INDICATOR_HEIGHT = 12;
var HALF_INDICATOR_HEIGHT = INDICATOR_HEIGHT / 2;
var CHILD_INDICATOR_HEIGHT = 44;
var BOTTOM_MARGIN = 30;
var UP_ALIGN = 12;

var Progress = function (_Component) {
  _inherits(Progress, _Component);

  function Progress(props) {
    _classCallCheck(this, Progress);

    var _this = _possibleConstructorReturn(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).call(this, props));

    _this.textDivs = [];
    _this.activeTable = {};

    (_this.props.verticalIndicators || []).forEach(function (e) {
      _this.activeTable[e.props.text] = e.props.defaultActive;
    });
    return _this;
  }

  _createClass(Progress, [{
    key: 'adjustProgress',
    value: function adjustProgress() {
      //when there is only one text  ??
      var isVertical = this.props.isVertical;


      if (isVertical && this.verticalIndicatorDivs && this.verticalIndicatorDivs.length > 0) {
        //!!in order to do the two animation simultaneously, I have to predict height before rendering
        // hard code height
        var height = 0;
        var len = this.verticalIndicatorDivs.length;
        this.verticalIndicatorDivs.forEach(function (e, index) {
          height += INDICATOR_HEIGHT;
          if (index !== len - 1) {
            height += BOTTOM_MARGIN;
          }
          if (e.props.isActive) {
            height += e.props.subIndicators.length * CHILD_INDICATOR_HEIGHT;
          }
        });
        var progress = _reactDom2.default.findDOMNode(this.progress);
        progress.style.setProperty("height", Math.max(height - HALF_INDICATOR_HEIGHT, 0) + "px");
        progress.style.setProperty("margin-top", HALF_INDICATOR_HEIGHT + "px");

        //find percent from verticalIndicatorDivs
        var pHeight = 0;
        var sameheight = false;
        for (var index = 0; index < len; index++) {
          var e = this.verticalIndicatorDivs[index];
          var allDone = e.props.doneIndicators.length === e.props.subIndicators.length;
          var next = this.verticalIndicatorDivs[index + 1];
          var hasNext = next && next.props.doneIndicators.length > 0;
          var percent100 = allDone && index === len - 1;

          if (e.props.isActive) {
            //expanded
            pHeight += INDICATOR_HEIGHT;
            pHeight += e.props.doneIndicators.length * CHILD_INDICATOR_HEIGHT;
            if (allDone && hasNext) {
              pHeight += BOTTOM_MARGIN;
            } else if (percent100) {
              pHeight -= UP_ALIGN; //align to last indicator
              sameheight = true;
            } else {
              pHeight -= UP_ALIGN; //align to sub indicator
            }
          } else {
            if (allDone && hasNext) {
              pHeight += INDICATOR_HEIGHT + BOTTOM_MARGIN;
            } else {
              pHeight += HALF_INDICATOR_HEIGHT;
            }

            if (index === len - 1) {
              sameheight = true;
            }
          }

          if (!allDone || !hasNext) {
            //progress ends here
            break;
          }
        }
        var progressBar = _reactDom2.default.findDOMNode(this.progressBar);
        progressBar.style.setProperty("height", Math.max(pHeight - HALF_INDICATOR_HEIGHT, 0) + "px");
        if (sameheight) {
          progress.style.setProperty("height", Math.max(pHeight - HALF_INDICATOR_HEIGHT, 0) + "px");
        }
      } else if (this.textDivs.length > 1 && isVertical) {
        var textDiv = _reactDom2.default.findDOMNode(this.textDiv);
        var _progress = _reactDom2.default.findDOMNode(this.progress);
        _progress.style.setProperty("height", textDiv.clientHeight + "px");

        var _progressBar = _reactDom2.default.findDOMNode(this.progressBar);
        var _percent = this.getPercent() / 100;
        _progressBar.style.setProperty("height", textDiv.clientHeight * _percent + "px");
      }
    }
  }, {
    key: 'onActiveToggle',
    value: function onActiveToggle(indicator, value) {
      this.activeTable[indicator.props.text] = value;
      this.forceUpdate();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.adjustProgress();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.adjustProgress();
    }
  }, {
    key: 'getPercent',
    value: function getPercent() {
      var percent = this.props.percent;
      percent = percent > 100 ? 100 : percent;
      percent = percent < 0 ? 0 : percent;
      return percent;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          style = _props.style,
          className = _props.className,
          isVertical = _props.isVertical,
          _props$percent = _props.percent,
          percent = _props$percent === undefined ? 0 : _props$percent,
          indicators = _props.indicators,
          verticalIndicators = _props.verticalIndicators,
          color = _props.color,
          theme = _props.theme,
          progressBarStyle = _props.progressBarStyle,
          progressBarClassname = _props.progressBarClassname,
          otherProps = _objectWithoutProperties(_props, ['style', 'className', 'isVertical', 'percent', 'indicators', 'verticalIndicators', 'color', 'theme', 'progressBarStyle', 'progressBarClassname']);

      percent = this.getPercent();

      //backward compatibility
      var _color = color || theme;

      var classNames = (0, _classnames2.default)('a-progress', className, {
        "a-vertical-progress": isVertical,
        "a-progress-dark": _color === "dark",
        "a-progress-white": _color === "white"
      });

      var wrapperCn = (0, _classnames2.default)("a-progress-wrapper", {
        "a-vertical-progress-wrapper": isVertical,
        "has-animation": verticalIndicators && verticalIndicators.length > 0
      });

      this.textDivs = [];
      var textCn = (0, _classnames2.default)("a-progress-text", _color, {
        "a-vertical-progress-text": isVertical,
        "a-horizontal-progress-text": !isVertical
      });
      var texts = void 0;
      var that = this;
      if (verticalIndicators && verticalIndicators.length > 0) {
        var verticalIndicatorDivs = verticalIndicators.map(function (e) {
          return _react2.default.cloneElement(e, {
            onToggle: that.onActiveToggle.bind(_this2),
            isActive: !!_this2.activeTable[e.props.text]
          });
        });
        this.verticalIndicatorDivs = verticalIndicatorDivs;
        texts = _react2.default.createElement(
          'div',
          { ref: function ref(e) {
              _this2.textDiv = e;
            }, className: textCn },
          verticalIndicatorDivs
        );
      } else if (indicators && indicators.length > 0) {
        var len = indicators.length;
        var indicatorDivs = indicators.map(function (e, index) {
          var isDone = index / (len - 1) * 100 <= percent;
          var indicatorCn = (0, _classnames2.default)('a-indicator', { 'a-progress-done': isDone });
          return _react2.default.createElement(
            'div',
            { ref: function ref(e) {
                _this2.textDivs.push(e);
              }, key: e, className: indicatorCn },
            e
          );
        });
        texts = _react2.default.createElement(
          'div',
          { ref: function ref(e) {
              _this2.textDiv = e;
            }, className: textCn },
          indicatorDivs
        );
      }

      var _progressBarStyle = void 0;
      if (!isVertical && !progressBarStyle) {
        _progressBarStyle = { width: percent + '%', height: '100%' };
      }

      return _react2.default.createElement(
        'div',
        Object.assign({ className: wrapperCn, style: style }, otherProps),
        _react2.default.createElement(
          'div',
          { className: classNames, ref: function ref(e) {
              _this2.progress = e;
            } },
          _react2.default.createElement('div', {
            className: (0, _classnames2.default)("a-progress-bar", progressBarClassname),
            style: progressBarStyle || _progressBarStyle,
            ref: function ref(e) {
              _this2.progressBar = e;
            }
          })
        ),
        _react2.default.createElement(
          'div',
          null,
          texts
        )
      );
    }
  }]);

  return Progress;
}(_react.Component);

Progress.defaultProps = {
  percent: 0
};


Progress.propTypes = {
  style: _propTypes2.default.object,
  progressBarStyle: _propTypes2.default.object,
  progressBarClassname: _propTypes2.default.string,
  className: _propTypes2.default.string,
  percent: _propTypes2.default.number,
  color: _propTypes2.default.oneOf(["default", "dark", "white"]),
  indicators: _propTypes2.default.arrayOf(_propTypes2.default.string),
  isVertical: _propTypes2.default.bool,

  verticalIndicators: _propTypes2.default.arrayOf(_propTypes2.default.any)
};

Progress.displayName = 'Progress';

exports.default = Progress;